export const gameData = [
    {
        index:1,
        name: "拳皇14",
        info: "THE KING OF FIGHTERS XIV",
        type: "格斗游戏$$精选大作",
        platform: "主机平台",
        hotLevel: 2,
        imgUrl: "game-KOF14.jpg"
    },
    {
        index:2,
        name: "侍魂 晓",
        info: "SAMURAI SHODOWN",
        type: "格斗游戏$$精选大作",
        platform: "主机平台",
        hotLevel: 2,
        imgUrl: "game-SAMURAISHODOWN.jpg"
    },
    {
        index:3,
        name: "生生不息",
        info: "Life goes on",
        type: "休闲游戏",
        platform: "主机平台",
        hotLevel: 4,
        imgUrl: "game-Lifegoeson.jpg"
    },
    {
        index:4,
        name: "美国篮球协会18",
        info: "NBA 2K18",
        type: "精选大作",
        platform: "主机平台",
        hotLevel: 1,
        imgUrl: "game-NBA2K18.jpg"
    },
    {
        index:5,
        name: "美国篮球协会19",
        info: "NBA 2K19",
        type: "精选大作",
        platform: "主机平台",
        hotLevel: 1,
        imgUrl: "game-NBA2K19.jpg"
    },
    {
        index:6,
        name: "坎巴拉太空计划",
        info: "Kerbal Space Program, KSP",
        type: "模拟类游戏$$精选大作",
        platform: "云游戏平台",
        hotLevel: 1,
        imgUrl: "game-KerbalSpaceProgram.jpg"
    },
    {
        index:7,
        name: "虚空之虫",
        info: "Nihilumbra",
        type: "休闲游戏",
        platform: "主机平台",
        hotLevel: 4,
        imgUrl: "game-Nihilumbra.jpg"
    },
    {
        index:8,
        name: "超级连击王",
        info: "SUPER COMBOMAN",
        type: "休闲游戏",
        platform: "主机平台",
        hotLevel: 4,
        imgUrl: "game-SUPERCOMBOMAN.jpg"
    },
    {
        index:9,
        name: "世界汽车拉力<br/>锦标赛8",
        info: "WRC 8",
        type: "模拟类游戏$$精选大作",
        platform: "主机平台",
        hotLevel: 1,
        imgUrl: "game-wrc8.jpg"
    },
    {
        index:10,
        name: "音量",
        info: "VOLUME",
        type: "休闲游戏",
        platform: "主机平台",
        hotLevel: 3,
        imgUrl: "game-VOLUME.jpg"
    },
    {
        index:11,
        name: "探险家斯皮兰卡",
        info: "Spelunker World",
        type: "休闲游戏",
        platform: "主机平台",
        hotLevel: 3,
        imgUrl: "game-SpelunkerWorld.jpg"
    },
    {
        index:12,
        name: "仰冲异界",
        info: "OBDUCTION",
        type: "休闲游戏",
        platform: "主机平台",
        hotLevel: 4,
        imgUrl: "game-OBDUCTION.jpg"
    },
    {
        index:13,
        name: "拳皇97",
        info: "THE KING OF FIGHTERS97",
        type: "格斗游戏$$怀旧经典",
        platform: "云游戏平台",
        hotLevel: 2,
        imgUrl: "game-KOF97.jpg"
    },
    {
        index:14,
        name: "拳皇98",
        info: "THE KING OF FIGHTERS98",
        type: "格斗游戏$$怀旧经典",
        platform: "云游戏平台",
        hotLevel: 2,
        imgUrl: "game-KOF98.jpg"
    },
    {
        index:15,
        name: "叛逆机械师",
        info: "ICONOCLASTS",
        type: "休闲游戏",
        platform: "云游戏平台",
        hotLevel: 2,
        imgUrl: "game-ICONOCLASTS.jpg"
    },
    {
        index:16,
        name: "合金弹头",
        info: "METAL SLUG",
        type: "休闲游戏$$怀旧经典",
        platform: "云游戏平台",
        hotLevel: 3,
        imgUrl: "game-METALSLUG.jpg"
    },
    {
        index:17,
        name: "合金弹头2",
        info: "METAL SLUG2",
        type: "休闲游戏$$怀旧经典",
        platform: "云游戏平台",
        hotLevel: 3,
        imgUrl: "game-METALSLUG2.jpg"
    },
    {
        index:18,
        name: "合金弹头3",
        info: "METAL SLUG3",
        type: "休闲游戏$$怀旧经典",
        platform: "云游戏平台",
        hotLevel: 3,
        imgUrl: "game-METALSLUG3.jpg"
    },
    {
        index:19,
        name: "战国传承3",
        info: "Sengoku3",
        type: "休闲游戏$$怀旧经典",
        platform: "云游戏平台",
        hotLevel: 3,
        imgUrl: "game-Sengoku3.jpg"
    },
    {
        index:20,
        name: "觅",
        info: "RIME",
        type: "休闲游戏$$精选大作",
        platform: "云游戏平台",
        hotLevel: 2,
        imgUrl: "game-RIME.jpg"
    },
    {
        index:21,
        name: "饿狼传说2",
        info: "THE NEWCOMERS",
        type: "格斗游戏$$怀旧经典",
        platform: "云游戏平台",
        hotLevel: 3,
        imgUrl: "game-THENEWCOMERS.jpg"
    },
    {
        index:22,
        name: "阿尔法任务2",
        info: "Alpha Mission2",
        type: "格斗游戏$$怀旧经典",
        platform: "云游戏平台",
        hotLevel: 4,
        imgUrl: "game-AlphaMission2.jpg"
    },
    {
        index:23,
        name: "月华剑士",
        info: "THE LAST BLADE",
        type: "格斗游戏$$怀旧经典",
        platform: "云游戏平台",
        hotLevel: 3,
        imgUrl: "game-THELASTBLADE.jpg"
    },
    {
        index:24,
        name: "真三国无双8",
        info: "Dynasty Warriors 9",
        type: "精选大作",
        platform: "云游戏平台",
        hotLevel: 1,
        imgUrl: "game-DynastyWarriors9.jpg"
    },
    {
        index:25,
        name: "三国志13",
        info: "Sangokushi13",
        type: "精选大作",
        platform: "云游戏平台",
        hotLevel: 1,
        imgUrl: "game-Sangokushi13.jpg"
    },
];

export const gameDetails = [
    {
        index:1,
        name: "拳皇14",
        type: 2,
        headImg: require('../../assets/gameDetails/KOF14/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/KOF14/top/kof_video.mp4'),
        detailImg: require('../../assets/gameDetails/KOF14/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/KOF14/LOGO.png'),
        blockNum: 3,
        buyLink:"https://kof.gamepoch.com/buykof14",
        officialSiteLink:"https://kof.gamepoch.com/",
        videoLink:"//player.bilibili.com/player.html?aid=713331166&bvid=BV1YX4y1T77A&cid=270084473&page=1",
        gameIntro:"《拳皇14》是继2010年7月11日的《拳皇13》后的KOF（THE KING OF FIGHTER）正统续作，将为玩家带来新的格斗篇章。自1994年首部作品推出以来，《拳皇》成为了让全球玩家为之狂热的格斗游戏系列。本作不仅继承了传统的「3V3组队对战」，原始的2D画面也进化为3D画面！另外还将导入全新的联网对战模式等。敬请期待拥有「50名角色」的KOF新篇章！",
        gameName:"拳皇14",
        gameDeveloper:"SNK",
        gamePlatform:"主机游戏",
        copyright:"© SNK CORPORATION ALL RIGHTS RESERVED.",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/KOF14/bottom/part1/part1.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1PW411P7Ao",title:"GAMEPOCH星游纪 PS4游戏<br/>《拳皇14》DLC人物连续技-OSWALD"},
            {index:1,imgUrl: require('../../assets/gameDetails/KOF14/bottom/part2/part2.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1PW411P7PB",title:"GAMEPOCH星游纪 PS4游戏<br/>《拳皇14》 中国队"},
            {index:2,imgUrl: require('../../assets/gameDetails/KOF14/bottom/part3/part3.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1PW411P7wQ",title:"GAMEPOCH星游纪 PS4游戏<br/>《拳皇14》 K"}
        ]
    },
    {
        index:2,
        name: "侍魂晓",
        type: 2,
        headImg: require('../../assets/gameDetails/SAMURAISHODOWN/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/SAMURAISHODOWN/top/main.mp4'),
        detailImg: require('../../assets/gameDetails/SAMURAISHODOWN/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/SAMURAISHODOWN/LOGO.png'),
        blockNum: 3,
        buyLink:"http://www.snkchina.com.cn/",
        officialSiteLink:"http://www.snkchina.com.cn/",
        videoLink:"//player.bilibili.com/player.html?aid=667762798&bvid=BV1va4y1x7vc&cid=181807602&page=1",
        gameIntro:`完全新作「侍魂 晓」、隆重登场！
                    侍魂系列自1993年诞生于世，用冷兵器进行战斗的这一剑戟格斗系列游戏风靡了全世界。历经11年岁月，完全新作终于闪亮登场！
                    本作在继承系列游戏极具魅力的世界观和游戏体验的同时、更面向究极绝美的画面做出进化。新追加的功能中，AI可学习玩家的战斗方式并制作出玩家的“替身”。
                    故事舞台位于日本、始于初代「侍魂」故事的一年前，各色剑豪坚守自身信念的物语就此开幕。`,
        gameName:"侍魂 晓",
        gameDeveloper:"SNK",
        gamePlatform:"主机游戏",
        copyright:"© SNK CORPORATION ALL RIGHTS RESERVED.",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/SAMURAISHODOWN/bottom/part1/part1.jpg'),vidioUrl:"https://weibo.com/tv/show/1034:4591056952426521?from=old_pc_videoshow",title:"《侍魂 晓》季票3"},
            {index:1,imgUrl: require('../../assets/gameDetails/SAMURAISHODOWN/bottom/part2/part2.jpg'),vidioUrl:"https://weibo.com/tv/show/1034:4615367511965734?from=old_pc_videoshow",title:"DLC新角色查姆查姆"},
            {index:2,imgUrl: require('../../assets/gameDetails/SAMURAISHODOWN/bottom/part3/part3.jpg'),vidioUrl:"https://weibo.com/tv/show/1034:4631261361406538?from=old_pc_videoshow",title:"DLC新角色高岭响剧情介绍"}
        ]
    },
    {
        index:3,
        name: "生生不息",
        type: 2,
        headImg: require('../../assets/gameDetails/Lifegoeson/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/Lifegoeson/top/main.mp4'),
        detailImg: require('../../assets/gameDetails/Lifegoeson/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/Lifegoeson/LOGO.png'),
        blockNum: 2,
        buyLink:"http://www.lifegoesongame.com/",
        officialSiteLink:"http://www.lifegoesongame.com/",
        videoLink:"//player.bilibili.com/player.html?aid=24547078&bvid=BV1PW411P7Nt&cid=41239625&page=1",
        gameIntro:`《生生不息》这款游戏的剧情很简单：有一位玩偶之国的国王，为了让玩偶得到真正的生命，决定去寻找生命之杯。他号召了大陆上成千上万的玩偶骑士去寻找生命圣杯。
                    出于对生命与幸福的追求，冒险者们热切地响应了这个荣耀万分的使命。
                    而后世的人们将会回想起这位国王坚韧不拔的精神，无与伦比的勇气，还有那些为目标而牺牲的玩偶勇士们。`,
        gameName:"生生不息",
        gameDeveloper:"Infinite Monkeys Entertainment Ltd",
        gamePlatform:"主机游戏",
        copyright:"© Infinite Monkeys Entertainment, Ltd. 2016",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/Lifegoeson/bottom/part1/main.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1qt411f76v",title:"《生生不息》奶牛关游戏评测"},
            {index:1,imgUrl: require('../../assets/gameDetails/Lifegoeson/bottom/part2/main.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1PW411P7Nt",title:"《生生不息》宣传视频"}
        ]
    },
    {
        index:4,
        name: "NBA 2K18",
        type: 2,
        headImg: require('../../assets/gameDetails/NBA2K18/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/NBA2K18/top/NBA2K18.mp4'),
        detailImg: require('../../assets/gameDetails/NBA2K18/intro/NBA2K18.jpg'),
        logoUrl: require('../../assets/gameDetails/NBA2K18/NBA2K18LOGO.png'),
        blockNum: 3,
        buyLink:"https://2k.com/",
        officialSiteLink:"https://2k.com/",
        videoLink:"//player.bilibili.com/player.html?aid=14048557&bvid=BV1Yx411t7XY&cid=22941641&page=1",
        gameIntro:`《NBA 2K18》是2K games旗下经典NBA系列新作。
                    作为经典篮球竞技类游戏，这款游戏将带领玩家体验真实又刺激的篮球比赛，众多大牌球星等待玩家的对抗。
                    该作更加注重真实性和细节，让人物的体型、动作和表情更加真实生动。
                    因此2K Sports对每个球员都进行了动作捕捉和面部扫描，让玩家在游玩的过程中获得更好的体验。`,
        gameName:"NBA 2K18",
        gameDeveloper:"2K Sports",
        gamePlatform:"主机游戏",
        copyright:"©2005-2017 Take-Two Interactive Software and its subsidiaries. 2K, the 2K logo, and Take-Two Interactive Software are all trademarks and/or registered trademarks of Take-Two Interactive Software, Inc. The NBA and NBA member team identifications are the intellectual property of NBA Properties, Inc. and the respective NBA member teams.©2017 NBA Properties, Inc. All rights reserved. The “PS” Family logo is a registered trademark and “PS4” is a trademark of Sony Interactive Entertainment Inc. All other trademarks are property of their respective owners. All rights reserved. *According to 2008-2017 Gamerankings.com and NPD Data.",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/NBA2K18/bottom/part1/part1.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1RW411P7HJ",title:"NBA 2K18part1"},
            {index:1,imgUrl: require('../../assets/gameDetails/NBA2K18/bottom/part2/part2.jpg'),vidioUrl:"https://www.bilibili.com/video/BV19W411P7QL",title:"part2"},
            {index:2,imgUrl: require('../../assets/gameDetails/NBA2K18/bottom/part3/part3.jpg'),vidioUrl:"https://www.bilibili.com/video/BV19W411P79c",title:"part3"}
        ]
    },
    {
        index:5,
        name: "NBA 2K19",
        type: 2,
        headImg: require('../../assets/gameDetails/NBA2K19/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/NBA2K19/top/NBA2K19.mp4'),
        detailImg: require('../../assets/gameDetails/NBA2K19/intro/NBA2K19.jpg'),
        logoUrl: require('../../assets/gameDetails/NBA2K19/NBA2K19LOGO.png'),
        blockNum: 3,
        buyLink:"https://2k.com/",
        officialSiteLink:"https://2k.com/",
        videoLink:"//player.bilibili.com/player.html?aid=28787269&bvid=BV1zs411g75g&cid=49882069&page=1",
        gameIntro:`《NBA 2K19》是2K Sports开发的《NBA 2K》系列作品。
                    从一流的画质和高度的可玩性，到突破性的游戏模式，再到令人神往的开放“社区”，20年来《NBA 2K》一直在不断刷新体育游戏的定义。
                    本次《NBA 2K19》将继续突破极限，让玩家获得接近真实的篮球体验、体验纯粹的篮球文化。`,
        gameName:"NBA 2K19",
        gameDeveloper:"2K Sports",
        gamePlatform:"主机游戏",
        copyright:"©2005-2018 Take-Two Interactive Software and its subsidiaries. 2K, the 2K logo, and Take-Two Interactive Software are all trademarks and/or registered trademarks of Take-Two Interactive Software, Inc. The NBA and NBA member team identifications are the intellectual property of NBA Properties, Inc. and the respective NBA member teams. ©2018 NBA Properties, Inc. All rights reserved. “PlayStation family mark” and “PS4 logo” are registered trademarks or trademarks of Sony Interactive Entertainment Inc. All other trademarks are property of their respective owners. All rights reserved. *According to 2008-2018 Gamerankings.com and NPD Data.",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/NBA2K19/bottom/part1/part1.jpg'),vidioUrl:"https://www.bilibili.com/video/BV14W411A7yv",title:"part1"},
            {index:1,imgUrl: require('../../assets/gameDetails/NBA2K19/bottom/part2/part2.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1eW411Q7oi",title:"part2"},
            {index:2,imgUrl: require('../../assets/gameDetails/NBA2K19/bottom/part3/part3.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1zs411g75g",title:"《NBA 2K19》预告片"}
        ]
    },
    {
        index:6,
        name: "坎巴拉太空计划",
        type: 1,
        headImg: require('../../assets/gameDetails/KerbalSpaceProgram/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/KerbalSpaceProgram/top/main.mp4'),
        detailImg: require('../../assets/gameDetails/KerbalSpaceProgram/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/KerbalSpaceProgram/LOGO.png'),
        blockNum: 0,
        buyLink:"#",
        officialSiteLink:"https://www.kerbalspaceprogram.com/",
        videoLink:"//player.bilibili.com/player.html?aid=930946664&bvid=BV1hK4y1X7AH&cid=348784911&page=1",
        gameIntro:"《坎巴拉太空计划》是一款拥有极高自由度的沙盒风格航空航天模拟经营游戏。在这里玩家可以扮演坎巴拉航空航天工作者。设计、建造并发射自己的火箭、航天飞机以及亚轨道飞行器，将航天器送入轨道，进而探索整个行星系。",
        gameName:"坎巴拉太空计划",
        gameDeveloper:"Squad",
        gamePlatform:"云游戏",
        copyright:"© 2011-2021 Take-Two Interactive, Inc. All Rights Reserved.",
        src: []
    },{
        index:7,
        name: "虚空之虫",
        type: 1,
        headImg: require('../../assets/gameDetails/Nihilumbra/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/Nihilumbra/top/main.jpg'),
        detailImg: require('../../assets/gameDetails/Nihilumbra/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/Nihilumbra/LOGO.png'),
        blockNum: 0,
        buyLink:"#",
        officialSiteLink:"https://beautifungames.com/",
        videoLink:"#",
        gameIntro:`《虚空之虫》 是一款风格独特的解谜闯关作品，游戏的主人公是一团黑色
        的虚空物质“Born” ，它在无意中发现了巨大的混沌世界，同时它也被这
        个世界诅咒变成了稻草人的模样。玩家要帮助它冲破重重机关离开这个诡
        异的世界，另外也要从黑暗侵蚀的追杀中逃生。游戏中的谜题设计相对而
        言便有趣了许多。随着关卡推进，玩家会获取各种不同的色彩，关卡中的
        机关就需要利用这些色彩才能顺利通过。除了这些机关，各种怪物也是阻
        碍我们前进的障碍，而玩家是没有攻击能力的，只能借助地形和色彩配合
        才能解决危机。`,
        gameName:"虚空之虫",
        gameDeveloper:"Beautifungames",
        gamePlatform:"主机游戏",
        copyright:"Copyright  ©2020 Published by Nacon and developed by KT Racing.",
        src: []
    },{
        index:8,
        name: "超级连击王",
        type: 2,
        headImg: require('../../assets/gameDetails/SUPERCOMBOMAN/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/SUPERCOMBOMAN/top/main.jpg'),
        detailImg: require('../../assets/gameDetails/SUPERCOMBOMAN/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/SUPERCOMBOMAN/LOGO.png'),
        blockNum: 2,
        buyLink:"#",
        officialSiteLink:"https://indienova.com/game/super-comboman",
        videoLink:"#",
        gameIntro:`这是一个动作英雄的新故事。他是一个拥有着很放克的梭鱼状头顶鼓包，身穿夏威夷衬衫，吃着巧克力曲奇饼干，挎着一个能说话的腰包（对的，能说话），充满能量的岛民。名字叫斯特拉格斯，他是工人阶级的英雄。帮助斯特拉格斯与名为兜兜可的大型建筑公司的一群坏家伙和大老板们战斗，在这场2D动作冒险之旅中保护自己和他的弟弟吧。通过各种关卡，从经典2D格斗游戏的动作列表中解锁各种疯狂的连击，可以将你的同事们打穿墙壁并获得报酬。`,
        gameName:"超级连击王",
        gameDeveloper:"Interabang Entertainment",
        gamePlatform:"主机游戏",
        copyright:"© 2015 INTERABANG ENTERTAINMENT INC All Rights Reserved",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/SUPERCOMBOMAN/bottom/part1/main.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1ex41147is",title:"超级连击王"},
            {index:1,imgUrl: require('../../assets/gameDetails/SUPERCOMBOMAN/bottom/part2/main.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1PW411P7Nq",title:"《超级连击王》预告片"}
        ]
    },
    {
        index:9,
        name: "WRC 8",
        type: 1,
        headImg: require('../../assets/gameDetails/WRC8/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/WRC8/top/wrc8.mp4'),
        detailImg: require('../../assets/gameDetails/WRC8/intro/WRC8.jpg'),
        logoUrl: require('../../assets/gameDetails/WRC8/WRC8LOGO.png'),
        blockNum: 0,
        buyLink:"#",
        officialSiteLink:"https://buy.wrcthegame.com/",
        videoLink:"//player.bilibili.com/player.html?aid=930976566&bvid=BV1rK4y1X7mk&cid=348782078&page=1",
        gameIntro:`《世界拉力锦标赛8》重视真实的驾驶体验，游戏将包含全新的物理效果以及重新设计的职业生涯模式。
                    游戏在实机演示中展示了不同的驾驶视角，而且画面看起来还算不错。
                    此外还有动态的天气模拟系统，在实机演示中也可以看到后期的赛程变为阴雨天气。
                    游戏中还有14个国家的100多条赛道以及一系列WRC历史上著名的赛车，并加入了每周挑战以及电竞模式。`,
        gameName:"世界汽车拉力锦标赛",
        gameDeveloper:"Kylotonn",
        gamePlatform:"主机游戏",
        copyright:"Copyright  ©2020 Published by Nacon and developed by KT Racing.",
        src: []
    },{
        index:10,
        name: "音量",
        type: 1,
        headImg: require('../../assets/gameDetails/VOLUME/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/VOLUME/top/main.mp4'),
        detailImg: require('../../assets/gameDetails/VOLUME/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/VOLUME/LOGO.png'),
        blockNum: 0,
        buyLink:"#",
        officialSiteLink:"http://www.volumegame.net/",
        videoLink:"https://www.gamepoch.cn/",
        gameIntro:`《音量》是一款潜入解密游戏。玩家将化身为未来守护者，灵活利用声音的力量，越过守卫和机关的重重包围，收集钻石、解开惊天秘密。
        多样化的道具：大量功能独特的道具—消音器、诱饵炸弹和各种陷阱道具。未来感的视听享受：独特的未来美术风格和令人记忆深刻的音乐，带来前所未有的游戏体验。`,
        gameName:"音量",
        gameDeveloper:"Bithell Games",
        gamePlatform:"PS4 PSV PSVR",
        copyright:"© 2015 Mike Bithell Games Limited.  ‘Volume’ and ‘Mike Bithell Games’ are trademarks of Mike Bithell Games Limited. All rights reserved",
        src: []
    },{
        index:11,
        name: "探险家斯皮兰卡",
        type: 1,
        headImg: require('../../assets/gameDetails/SpelunkerWorld/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/SpelunkerWorld/top/main.mp4'),
        detailImg: require('../../assets/gameDetails/SpelunkerWorld/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/SpelunkerWorld/LOGO.png'),
        blockNum: 0,
        buyLink:"#",
        officialSiteLink:"https://spelunker.gamepoch.com/?id=5",
        videoLink:"https://www.gamepoch.cn/",
        gameIntro:`大家一起踏上洞窟探险的旅程吧！《探险家斯皮兰卡》是免费下载的横版动作游戏。成为菜鸟洞窟探险家向着神秘的洞窟进发！但是洞窟中危险重重，稍有疏忽可是会送命的。在6人的在线团队模式中和小伙伴们齐心协力攻略洞窟吧，即使失误也会有小伙伴来帮助你！而且，人数越多通关奖励也越丰富！本作新登场的宠物也拥有各种各样的特殊能力，对于斯皮兰卡的冒险大有帮助！还可以用在洞窟中收集到的装备来打造只属于自己的独一无二的形象！另外还有新角色登场！？而洞窟深处等待你的是…???`,
        gameName:"探险家斯皮兰卡",
        gameDeveloper:"Tozai Games",
        gamePlatform:"主机游戏",
        copyright:`© 2018 SQUARE ENIX CO, LTD. 版权所有
        © 1983-2018 Timothy G Martin 与Tozai, Inc. 版权所有
        探险家斯皮兰卡是Square Enix Holdings Co., Ltd注册的一个商标
        Tozai Games是Tozai, Inc.注册的一个商标,在美国和其他国家注册或受保护
        SQUARE ENIX和SQUARE ENIX的标志已被注册为Square Enix Holdings Co, Ltd.的商标`,
        src: []
    },{
        index:12,
        name: "仰冲异界",
        type: 2,
        headImg: require('../../assets/gameDetails/OBDUCTION/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/OBDUCTION/top/main.jpg'),
        detailImg: require('../../assets/gameDetails/OBDUCTION/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/OBDUCTION/LOGO.png'),
        blockNum: 1,
        buyLink:"#",
        officialSiteLink:"https://www.gog.com/game/obduction",
        videoLink:"#",
        gameIntro:`作为《神秘岛》系列的精神续作，《仰冲异界》是步行冒险解谜游戏的新篇章。坠入神秘荒芜的哈纳斯，遍地黄沙，空无一人。在这个开阔迷人的世界中搜寻线索，解开烧脑的谜题，探知哈纳斯的真相，找到归乡之路。`,
        gameName:"仰冲异界",
        gameDeveloper:"Cyan Inc.",
        gamePlatform:"PS(VR)",
        copyright:"® Copyright 2017 Cyan, Inc . All rights reserved. Obduction ® and Cyan are registered trademarks of Cyan, Inc. Legendary VR logo © 2017 Legendary. Unreal, Unreal Engine, the circle-U logo and the Powered By Unreal Engine Logo are trademarks or registered trademarks of Epic Games, Inc. in the United States and elsewhere.",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/OBDUCTION/bottom/part1/main.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1yb411872h",title:"《仰冲异界》宣传视频"}

        ]
    },{
        index:13,
        name: "拳皇97",
        type: 1,
        headImg: require('../../assets/gameDetails/KOF97/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/KOF97/top/kof97.mp4'),
        detailImg: require('../../assets/gameDetails/KOF97/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/KOF97/LOGO.png'),
        blockNum: 0,
        buyLink:"#",
        officialSiteLink:"https://www.snk-corp.co.jp/us/",
        videoLink:"//player.bilibili.com/player.html?aid=57131740&bvid=BV1dx411d7Je&cid=99771907&page=1",
        gameIntro:`拳皇97，是一款SNK公司发布于1997年的街机格斗游戏，在国内非常受欢迎，相比拳皇前三个版本各方面均有较大改进，是拳皇系列的成熟之作。《拳皇97》在中国非常受欢迎，直至今日，KOF97在全国各地街机厅也依然长盛不衰。`,
        gameName:"拳皇97",
        gameDeveloper:"SNK",
        gamePlatform:"云游戏",
        copyright:"© SNK CORPORATION ALL RIGHTS RESERVED.",
        src: []
    },
    {
        index:14,
        name: "牧场星球",
        type: 2,
        headImg: require('../../assets/gameDetails/RhythmPlanet/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/RhythmPlanet/top/RhythmPlanet.mp4'),
        detailImg: require('../../assets/gameDetails/RhythmPlanet/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/RhythmPlanet/RhythmPlanetLOGO.png'),
        blockNum: 3,
        buyLink:"#",
        officialSiteLink:"https://www.gamepoch.com/detail?id=14",
        videoLink:"//player.bilibili.com/player.html?aid=24546941&bvid=BV1PW411P7FK&cid=41239345&page=1",
        gameIntro:"《牧场星球》是由奥嘉科技开发、GAMEPOCH星游纪发行的一款画风萌贱可爱，玩法欢乐搞笑的VR游戏。游戏上手简单，适合朋友聚会、家庭娱乐。",
        gameName:"牧场星球",
        gameDeveloper:"奥嘉科技",
        gamePlatform:"主机游戏 VR2",
        copyright:"©2023 奥嘉科技",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/RhythmPlanet/bottom/part1/part1.jpg'),vidioUrl:"https://video.weibo.com/show?fid=1034:4903129007980611",title:"PS VR2 “Rhythem Planet”海外同步上线"},
            {index:1,imgUrl: require('../../assets/gameDetails/RhythmPlanet/bottom/part2/part2.jpg'),vidioUrl:"https://video.weibo.com/show?fid=1034:4872351012290611",title:"首款国行PlayStation-VR2游戏《牧场星球》"},
            {index:2,imgUrl: require('../../assets/gameDetails/RhythmPlanet/bottom/part3/part3.jpg'),vidioUrl:"https://video.weibo.com/show?fid=1034:4876683229200433",title:"PS VR2《牧场星球》线下体验日实况"}
        ]
    },{
        index:15,
        name: "美国篮球协会20",
        type: 2,
        headImg: require('@/assets/gameDetails/NBA2K20/top/adaptivity.jpg'),
        headVideo: require('@/assets/gameDetails/NBA2K20/top/NBA2K20.mp4'),
        detailImg: require('@/assets/gameDetails/NBA2K20/intro/main.jpg'),
        logoUrl: require('@/assets/gameDetails/NBA2K20/NBA2K20LOGO.png'),
        blockNum: 3,
        buyLink:"https://2k.com/",
        officialSiteLink:"https://2k.com/",
        videoLink:"//player.bilibili.com/player.html?aid=67976239&bvid=BV1DJ411c7Tv&cid=117821186&page=1",
        gameIntro:"《NBA 2K20》是篮球体育游戏《NBA 2K》系列的续作，这一作将以突破性的游戏模拟以及无与伦比的玩家控制重新定义运动游戏的可能性。",
        gameName:"《NBA 2K20》美国篮球协会20",
        gameDeveloper:"2K Sports",
        gamePlatform:"主机游戏",
        copyright:`©2005-2019 Take-Two Interactive Software, Inc. and its subsidiaries.2K, the 2K logo, and Take-Two Interactive Software are all trademarks and/orregisteredtrademarks of Take-Two I
        nteractive Software, Inc. The NBA and NBAmember team identifications are the intellectual property of NBA Properties,Inc. and the respective NBA member teams. 
        ©2019 NBA Properties, Inc. AllRights Reserved. Officially licensed product of the National Basketball PlayersAssociation.`,
        src: [
            {index:'0',imgUrl: require('@/assets/gameDetails/NBA2K20/bottom/part1/part1.jpg'),vidioUrl:"https://weibo.com/tv/show/1034:4479432140718095?from=old_pc_videoshow",title:"NBA 2K20 MT模式"},
            {index:'1',imgUrl: require('@/assets/gameDetails/NBA2K20/bottom/part2/part2.jpg'),vidioUrl:"https://weibo.com/tv/show/1034:4471348357955593?from=old_pc_videoshow",title:"NBA2K20 全明星宣传片"},
            {index:'2',imgUrl: require('@/assets/gameDetails/NBA2K20/bottom/part3/part3.jpg'),vidioUrl:"https://weibo.com/tv/show/1034:4453185385857037?from=old_pc_videoshow",title:"NBA2K20-圣诞-麦迪卡包"}
        ]
    },

];


export const gameDetails_En = [
    {
        index:1,
        name: "THE KING OF FIGHTERS XIV",
        type: 2,
        headImg: require('../../assets/gameDetails/KOF14/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/KOF14/top/kof_video.mp4'),
        detailImg: require('../../assets/gameDetails/KOF14/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/KOF14/LOGO.png'),
        blockNum: 3,
        buyLink:"https://kof.gamepoch.com/buykof14",
        officialSiteLink:"https://kof.gamepoch.com/",
        videoLink:"//player.bilibili.com/player.html?aid=713331166&bvid=BV1YX4y1T77A&cid=270084473&page=1",
        gameIntro:"KOF XIV is the newest entry in the acclaimed THE KING OF FIGHTERS series of fighting games. Lead by veteran creator and FATAL FURY creator Yasuyuki Oda, KOF XIV takes the iconic gameplay that the series is known for while implementing new 3D visuals, a first for a mainline entry in the series! Featuring a robust roster of 50 characters in the base game along with 4 DLC characters, including both returning fan favorites and new characters, this entry is perfect for veterans and newcomers alike!",
        gameName:"THE KING OF FIGHTERS XIV",
        gameDeveloper:"SNK",
        gamePlatform:"Console Games",
        copyright:"© SNK CORPORATION ALL RIGHTS RESERVED.",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/KOF14/bottom/part1/part1.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1PW411P7Ao",title:"GAMEPOCH / PS4<br/>Combo of OSWALD - KOFXIV DLC"},
            {index:1,imgUrl: require('../../assets/gameDetails/KOF14/bottom/part2/part2.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1PW411P7PB",title:"GAMEPOCH / PS4<br/>Chinese Performance - KOFXIV"},
            {index:2,imgUrl: require('../../assets/gameDetails/KOF14/bottom/part3/part3.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1PW411P7wQ",title:"GAMEPOCH / PS4<br/>K - KOFXIV"}
        ]
    },
    {
        index:2,
        name: "SAMURAI SHODOWN",
        type: 2,
        headImg: require('../../assets/gameDetails/SAMURAISHODOWN/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/SAMURAISHODOWN/top/main.mp4'),
        detailImg: require('../../assets/gameDetails/SAMURAISHODOWN/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/SAMURAISHODOWN/LOGO.png'),
        blockNum: 3,
        buyLink:"http://www.snkchina.com.cn/",
        officialSiteLink:"http://www.snkchina.com.cn/",
        videoLink:"//player.bilibili.com/player.html?aid=667762798&bvid=BV1va4y1x7vc&cid=181807602&page=1",
        gameIntro:`SAMURAI series was born in 1993. The FTG series features cold weapon fighting includes sword and halberd had soon prevailed the world. And a decade’s deposition means a brand new flawless work ! This edition not only inherits the charming world outlook and game experience of the series of games, but also makes evolution for the extremely beautiful pictures. In the newly added functions, AI is able to resemble the fighting style of players and form “avatars”. The story was happened in Japan, one year before the original Samurai plot, aims to express the tale of different swordsmen who stick to their beliefs`,
        gameName:"SAMURAI SHODOWN",
        gameDeveloper:"SNK",
        gamePlatform:"Console Games",
        copyright:"© SNK CORPORATION ALL RIGHTS RESERVED.",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/SAMURAISHODOWN/bottom/part1/part1.jpg'),vidioUrl:"https://weibo.com/tv/show/1034:4591056952426521?from=old_pc_videoshow",title:"Samurai Showdown DLC-Part 3"},
            {index:1,imgUrl: require('../../assets/gameDetails/SAMURAISHODOWN/bottom/part2/part2.jpg'),vidioUrl:"https://weibo.com/tv/show/1034:4615367511965734?from=old_pc_videoshow",title:"New Character Added In DLC- Cham Cham"},
            {index:2,imgUrl: require('../../assets/gameDetails/SAMURAISHODOWN/bottom/part3/part3.jpg'),vidioUrl:"https://weibo.com/tv/show/1034:4631261361406538?from=old_pc_videoshow",title:"New Character Added In DLC - Hibiki Takane"}
        ]
    },
    {
        index:3,
        name: "Life goes on ",
        type: 2,
        headImg: require('../../assets/gameDetails/Lifegoeson/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/Lifegoeson/top/main.mp4'),
        detailImg: require('../../assets/gameDetails/Lifegoeson/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/Lifegoeson/LOGO.png'),
        blockNum: 2,
        buyLink:"http://www.lifegoesongame.com/",
        officialSiteLink:"http://www.lifegoesongame.com/",
        videoLink:"//player.bilibili.com/player.html?aid=24547078&bvid=BV1PW411P7Nt&cid=41239625&page=1",
        gameIntro:`Life Goes On: Done to Death is a comically-morbid platformer where you guide heroic knights to their demise and use the dead bodies to solve puzzles. Wanting to live forever, a mighty king sends his army of knights to find the Cup of Life. On this quest, you will summon knight after knight to be brutally sacrificed. As you journey through treacherous and trap-ridden worlds, you’ll show no mercy to solve each challenging puzzle.`,
        gameName:"Life goes on ",
        gameDeveloper:"Infinite Monkeys Entertainment Ltd",
        gamePlatform:"Console Games",
        copyright:"© Infinite Monkeys Entertainment, Ltd. 2016",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/Lifegoeson/bottom/part1/main.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1qt411f76v",title:"Life Goes On - Game Experience "},
            {index:1,imgUrl: require('../../assets/gameDetails/Lifegoeson/bottom/part2/main.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1PW411P7Nt",title:"Life Goes On - Trailer"}
        ]
    },
    {
        index:4,
        name: "NBA 2K18",
        type: 2,
        headImg: require('../../assets/gameDetails/NBA2K18/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/NBA2K18/top/NBA2K18.mp4'),
        detailImg: require('../../assets/gameDetails/NBA2K18/intro/NBA2K18.jpg'),
        logoUrl: require('../../assets/gameDetails/NBA2K18/NBA2K18LOGO.png'),
        blockNum: 3,
        buyLink:"https://2k.com/",
        officialSiteLink:"https://2k.com/",
        videoLink:"//player.bilibili.com/player.html?aid=14048557&bvid=BV1Yx411t7XY&cid=22941641&page=1",
        gameIntro:`NBA 2K18 is a new title for NBA series games under 2K games.
        As a classic basketball game, the game will lead players to experience the most real and exciting basketball game, as well as many big names who are waiting for players to fight.
        The game pays more attention to authenticity and details, making the character’s body shape, action and expression more realistic and vivid.
        Therefore, 2K sports carries out motion capture and face scanning for each and every player, so that the gamers can get a better experience in the process of playing.`,
        gameName:"NBA 2K18",
        gameDeveloper:"2K Sports",
        gamePlatform:"Console Games",
        copyright:"©2005-2017 Take-Two Interactive Software and its subsidiaries. 2K, the 2K logo, and Take-Two Interactive Software are all trademarks and/or registered trademarks of Take-Two Interactive Software, Inc. The NBA and NBA member team identifications are the intellectual property of NBA Properties, Inc. and the respective NBA member teams.©2017 NBA Properties, Inc. All rights reserved. The “PS” Family logo is a registered trademark and “PS4” is a trademark of Sony Interactive Entertainment Inc. All other trademarks are property of their respective owners. All rights reserved. *According to 2008-2017 Gamerankings.com and NPD Data.",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/NBA2K18/bottom/part1/part1.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1RW411P7HJ",title:"Review on NBA 2K18 Highlights"},
            {index:1,imgUrl: require('../../assets/gameDetails/NBA2K18/bottom/part2/part2.jpg'),vidioUrl:"https://www.bilibili.com/video/BV19W411P7QL",title:"Review on NBA 2K18 Highlights 2"},
            {index:2,imgUrl: require('../../assets/gameDetails/NBA2K18/bottom/part3/part3.jpg'),vidioUrl:"https://www.bilibili.com/video/BV19W411P79c",title:"Review on NBA 2K18 Highlights 3"}
        ]
    },
    {
        index:5,
        name: "NBA 2K19",
        type: 2,
        headImg: require('../../assets/gameDetails/NBA2K19/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/NBA2K19/top/NBA2K19.mp4'),
        detailImg: require('../../assets/gameDetails/NBA2K19/intro/NBA2K19.jpg'),
        logoUrl: require('../../assets/gameDetails/NBA2K19/NBA2K19LOGO.png'),
        blockNum: 3,
        buyLink:"https://2k.com/",
        officialSiteLink:"https://2k.com/",
        videoLink:"//player.bilibili.com/player.html?aid=28787269&bvid=BV1zs411g75g&cid=49882069&page=1",
        gameIntro:`NBA 2K19 is a latest title for NBA 2K series developed by 2K sports.
        From the first-class picture quality and high playability, to the revolutionary game mode, and then to the fascinating open "community", NBA 2K has been constantly refreshing the definition of sports games in the past 20 years.
        This "NBA 2K19" will continue to break through the boundaries, let gamers get as close as possible to the real basketball experience, experience the purest basketball culture.`,
        gameName:"NBA 2K19",
        gameDeveloper:"2K Sports",
        gamePlatform:"Console Games",
        copyright:"©2005-2018 Take-Two Interactive Software and its subsidiaries. 2K, the 2K logo, and Take-Two Interactive Software are all trademarks and/or registered trademarks of Take-Two Interactive Software, Inc. The NBA and NBA member team identifications are the intellectual property of NBA Properties, Inc. and the respective NBA member teams. ©2018 NBA Properties, Inc. All rights reserved. “PlayStation family mark” and “PS4 logo” are registered trademarks or trademarks of Sony Interactive Entertainment Inc. All other trademarks are property of their respective owners. All rights reserved. *According to 2008-2018 Gamerankings.com and NPD Data.",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/NBA2K19/bottom/part1/part1.jpg'),vidioUrl:"https://www.bilibili.com/video/BV14W411A7yv",title:"NBA 2K19 20th Anniversary Edition"},
            {index:1,imgUrl: require('../../assets/gameDetails/NBA2K19/bottom/part2/part2.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1eW411Q7oi",title:"NBA 2K19-My Career Mode Trailer"},
            {index:2,imgUrl: require('../../assets/gameDetails/NBA2K19/bottom/part3/part3.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1zs411g75g",title:"NBA 2K19-Trailer"}
        ]
    },
    {
        index:6,
        name: "Kerbal space program",
        type: 1,
        headImg: require('../../assets/gameDetails/KerbalSpaceProgram/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/KerbalSpaceProgram/top/main.mp4'),
        detailImg: require('../../assets/gameDetails/KerbalSpaceProgram/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/KerbalSpaceProgram/LOGO.png'),
        blockNum: 0,
        buyLink:"#",
        officialSiteLink:"https://www.kerbalspaceprogram.com/",
        videoLink:"//player.bilibili.com/player.html?aid=930946664&bvid=BV1hK4y1X7AH&cid=348784911&page=1",
        gameIntro:`Kerbal space program
        The Kerbal space program is a sandbox style Aerospace simulation game with high degree of freedom. 
        In the game, players can play as the Kerbal Aerospace worker in order to design, build and launch their own rockets, 
        space shuttle and sub orbital vehicles, and send them into orbit, and then explore the whole planetary system.`,
        gameName:"Kerbal space program",
        gameDeveloper:"Squad",
        gamePlatform:"Cloud Game",
        copyright:"© 2011-2021 Take-Two Interactive, Inc. All Rights Reserved.",
        src: []
    },{
        index:7,
        name: "Nihilumbra",
        type: 1,
        headImg: require('../../assets/gameDetails/Nihilumbra/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/Nihilumbra/top/main.jpg'),
        detailImg: require('../../assets/gameDetails/Nihilumbra/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/Nihilumbra/LOGO.png'),
        blockNum: 0,
        buyLink:"#",
        officialSiteLink:"https://beautifungames.com/",
        videoLink:"#",
        gameIntro:`Discover the beautiful world of Nihilumbra and join Born on his adventure to find himself whilst trying to escape from his inevitable curse. 
        Born was created from the absolute nothingness: The Void. But somehow he separates himself from the black emptiness and appears in the world. This is where his long odyssey begins, in which he will learn how to use the colors around him to gain powerful abilities and transform the world.`,
        gameName:"Nihilumbra",
        gameDeveloper:"Beautifungames",
        gamePlatform:"Console Games",
        copyright:"Copyright  ©2020 Published by Nacon and developed by KT Racing.",
        src: []
    },{
        index:8,
        name: "SUPER COMBOMAN ",
        type: 2,
        headImg: require('../../assets/gameDetails/SUPERCOMBOMAN/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/SUPERCOMBOMAN/top/main.jpg'),
        detailImg: require('../../assets/gameDetails/SUPERCOMBOMAN/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/SUPERCOMBOMAN/LOGO.png'),
        blockNum: 2,
        buyLink:"#",
        officialSiteLink:"https://indienova.com/game/super-comboman",
        videoLink:"#",
        gameIntro:`Enter a new Action Hero. An energetic islander with funked up mullet nugget, wearer of loud Hawaiian shirts, eater of chocolate chip cookies, and owner of a talking fanny pack (yeah, a talking fanny pack). His name is Struggles, and he’s the working class hero with an 'All You Can' attitude, a spinning pile driver, and fireball moves to match.

        Help Struggles battle an army of baddies and Mega bosses from a giant construction organization called DoDoCo. Traverse through vibrant levels, unlock powerful moves ripped straight from the pages of classic 2D fighter games' move lists and punch your co-workers through brick walls in order to collect a paycheck along the way. Help Struggles keep a roof over his and his brother's head in this action packed 2D adventure.`,
        gameName:"SUPER COMBOMAN ",
        gameDeveloper:"Interabang Entertainment",
        gamePlatform:"Console Games",
        copyright:"© 2015 INTERABANG ENTERTAINMENT INC All Rights Reserved",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/SUPERCOMBOMAN/bottom/part1/main.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1ex41147is",title:"SUPER COMBOMAN"},
            {index:1,imgUrl: require('../../assets/gameDetails/SUPERCOMBOMAN/bottom/part2/main.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1PW411P7Nq",title:"SUPER COMBOMAN - Trailer"}
        ]
    },
    {
        index:9,
        name: "WRC 8",
        type: 1,
        headImg: require('../../assets/gameDetails/WRC8/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/WRC8/top/wrc8.mp4'),
        detailImg: require('../../assets/gameDetails/WRC8/intro/WRC8.jpg'),
        logoUrl: require('../../assets/gameDetails/WRC8/WRC8LOGO.png'),
        blockNum: 0,
        buyLink:"#",
        officialSiteLink:"https://buy.wrcthegame.com/",
        videoLink:"//player.bilibili.com/player.html?aid=930976566&bvid=BV1rK4y1X7mk&cid=348782078&page=1",
        gameIntro:`FIA World Rally Championship ©2020 Published by Nacon and developed by KT Racing. An official product of the FIA World Rally Championship. All rights reserved. `,
        gameName:"WRC 8",
        gameDeveloper:"Kylotonn",
        gamePlatform:"Console Games",
        copyright:"Copyright  ©2020 Published by Nacon and developed by KT Racing.",
        src: []
    },{
        index:10,
        name: "VOLUME",
        type: 1,
        headImg: require('../../assets/gameDetails/VOLUME/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/VOLUME/top/main.mp4'),
        detailImg: require('../../assets/gameDetails/VOLUME/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/VOLUME/LOGO.png'),
        blockNum: 0,
        buyLink:"#",
        officialSiteLink:"http://www.volumegame.net/",
        videoLink:"https://www.gamepoch.cn/",
        gameIntro:`Locksley doesn't kill. That would be far too easy. Instead, he commits his crimes through stealth. Sneaking, distracting, avoiding. He is never seen, and seldom heard. As he grows in popularity and notoriety, so will his inventory. An arsenal of gadgets await discovery in a quest to rob from the rich and give to the unheard.`,
        gameName:"VOLUME",
        gameDeveloper:"Bithell Games",
        gamePlatform:"PS4 PSV PSVR",
        copyright:"© 2015 Mike Bithell Games Limited.  ‘Volume’ and ‘Mike Bithell Games’ are trademarks of Mike Bithell Games Limited. All rights reserved",
        src: []
    },{
        index:11,
        name: "Spelunker World",
        type: 1,
        headImg: require('../../assets/gameDetails/SpelunkerWorld/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/SpelunkerWorld/top/main.mp4'),
        detailImg: require('../../assets/gameDetails/SpelunkerWorld/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/SpelunkerWorld/LOGO.png'),
        blockNum: 0,
        buyLink:"#",
        officialSiteLink:"https://spelunker.gamepoch.com/?id=5",
        videoLink:"https://www.gamepoch.cn/",
        gameIntro:`Embark on an underground adventure! Spelunker World is a free-to-play side-scrolling action game. Play as underground explorer "Spelunker" and venture in to the mysterious dungeons! Enjoy online multiply for up to 6 people! A new pet introduced! Change of outfits! New Characters! What awaits at the deepest parts of the caves?`,
        gameName:"Spelunker World",
        gameDeveloper:"Tozai Games",
        gamePlatform:"Console Games",
        copyright:`© 2018 SQUARE ENIX CO, LTD. 版权所有
        © 1983-2018 Timothy G Martin 与Tozai, Inc. 版权所有
        探险家斯皮兰卡是Square Enix Holdings Co., Ltd注册的一个商标
        Tozai Games是Tozai, Inc.注册的一个商标,在美国和其他国家注册或受保护
        SQUARE ENIX和SQUARE ENIX的标志已被注册为Square Enix Holdings Co, Ltd.的商标`,
        src: []
    },{
        index:12,
        name: "OBDUCTION",
        type: 2,
        headImg: require('../../assets/gameDetails/OBDUCTION/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/OBDUCTION/top/main.jpg'),
        detailImg: require('../../assets/gameDetails/OBDUCTION/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/OBDUCTION/LOGO.png'),
        blockNum: 1,
        buyLink:"#",
        officialSiteLink:"https://www.gog.com/game/obduction",
        videoLink:"#",
        gameIntro:`As you walk beside the lake on a cloudy night, a curious, organic artifact falls from the starry sky and inexplicably, without asking permission, transports you across the universe. You’ve been abducted from your cozy existence and added into an alien landscape with pieces of Earth from unexpected times and places. `,
        gameName:"OBDUCTION",
        gameDeveloper:"Cyan Inc.",
        gamePlatform:"PS(VR)",
        copyright:"® Copyright 2017 Cyan, Inc . All rights reserved. Obduction ® and Cyan are registered trademarks of Cyan, Inc. Legendary VR logo © 2017 Legendary. Unreal, Unreal Engine, the circle-U logo and the Powered By Unreal Engine Logo are trademarks or registered trademarks of Epic Games, Inc. in the United States and elsewhere.",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/OBDUCTION/bottom/part1/main.jpg'),vidioUrl:"https://www.bilibili.com/video/BV1yb411872h",title:"OBDUCTION - Trailer"}

        ]
    },{
        index:13,
        name: "THE KING OF FIGHTERS97 ",
        type: 1,
        headImg: require('../../assets/gameDetails/KOF97/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/KOF97/top/kof97.mp4'),
        detailImg: require('../../assets/gameDetails/KOF97/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/KOF97/LOGO.png'),
        blockNum: 0,
        buyLink:"#",
        officialSiteLink:"https://www.snk-corp.co.jp/us/",
        videoLink:"//player.bilibili.com/player.html?aid=57131740&bvid=BV1dx411d7Je&cid=99771907&page=1",
        gameIntro:`THE KING OF FIGHTERS '97
        KOF '97 is an arcade fighting game released by SNK company in 1997, which is very popular in China. Compared with the first three versions of KOF games, great improvements drips in all aspects. It is a mature work of KOF series. Up to now, KOF '97 is still popular in arcade halls all over the country.`,
        gameName:"THE KING OF FIGHTERS97 ",
        gameDeveloper:"SNK",
        gamePlatform:"Cloud Game",
        copyright:"© SNK CORPORATION ALL RIGHTS RESERVED.",
        src: []
    },
    {
        index:14,
        name: "RhythmPlanet",
        type: 2,
        headImg: require('../../assets/gameDetails/RhythmPlanet/top/adaptivity.jpg'),
        headVideo: require('../../assets/gameDetails/RhythmPlanet/top/RhythmPlanet.mp4'),
        detailImg: require('../../assets/gameDetails/RhythmPlanet/intro/main.jpg'),
        logoUrl: require('../../assets/gameDetails/RhythmPlanet/RhythmPlanetLOGO.png'),
        blockNum: 3,
        buyLink:"https://2k.com/",
        officialSiteLink:"https://2k.com/",
        videoLink:"//player.bilibili.com/player.html?aid=24546941&bvid=BV1PW411P7FK&cid=41239345&page=1",
        gameIntro:`"Rhythm Planet" is a cute and hilarious game developed by Aoga Technology and published by GAMEPOCH. The game perfectly combines music rhythm with new features of PSVR2, such as adaptive triggers, head-mounted vibration feedback, and surround sound, allowing players to enjoy the fun on dozens of "super parties".

        If you are experiencing PSVR2 for the first time, "Rhythm Planet" is a great introductory experience. The game is easy to pick up and designed for family fun, suitable for friends' gatherings and family entertainment. With a good rhythm sense, you can dominate the party.
        
        Whether you are a game novice or a veteran player, "Rhythm Planet" will bring you endless fun and excitement, making your PSVR2 experience more colorful. Come and experience this cute and hilarious game!`,
        gameName:"RhythmPlanet",
        gameDeveloper:"Aoga Technology",
        gamePlatform:"PS VR2",
        copyright:"©2023 Aoga Technology",
        src: [
            {index:0,imgUrl: require('../../assets/gameDetails/RhythmPlanet/bottom/part1/part1.jpg'),vidioUrl:"https://video.weibo.com/show?fid=1034:4903129007980611",title:"PS VR2 “Rhythem Planet”海外同步上线"},
            {index:1,imgUrl: require('../../assets/gameDetails/RhythmPlanet/bottom/part2/part2.jpg'),vidioUrl:"https://video.weibo.com/show?fid=1034:4872351012290611",title:"首款国行PlayStation-VR2游戏《牧场星球》"},
            {index:2,imgUrl: require('../../assets/gameDetails/RhythmPlanet/bottom/part3/part3.jpg'),vidioUrl:"https://video.weibo.com/show?fid=1034:4876683229200433",title:"PS VR2《牧场星球》线下体验日实况"}
        ]
    },{
        index:15,
        name: "NBA 2K20",
        type: 2,
        headImg: require('@/assets/gameDetails/NBA2K20/top/adaptivity.jpg'),
        headVideo: require('@/assets/gameDetails/NBA2K20/top/NBA2K20.mp4'),
        detailImg: require('@/assets/gameDetails/NBA2K20/intro/main.jpg'),
        logoUrl: require('@/assets/gameDetails/NBA2K20/NBA2K20LOGO.png'),
        blockNum: 3,
        buyLink:"#",
        officialSiteLink:"https://www.gamepoch.com/detail?id=15",
        videoLink:"//player.bilibili.com/player.html?aid=67976239&bvid=BV1DJ411c7Tv&cid=117821186&page=1",
        gameIntro:`"NBA 2K20" is a sequel to the basketball sports game series "NBA 2K."This game sets out to 
        redefine the boundaries of sports gaming with its revolutionary game simulation and unmatched player control, offering an unparalleled experience for players.`,
        gameName:"《NBA 2K20》",
        gameDeveloper:"2K Sports",
        gamePlatform:"Console Game",
        copyright:`©2005-2019 Take-Two Interactive Software, Inc. and its subsidiaries.2K, the 2K logo, and Take-Two Interactive Software are all trademarks and/orregisteredtrademarks of Take-Two I
        nteractive Software, Inc. The NBA and NBAmember team identifications are the intellectual property of NBA Properties,Inc. and the respective NBA member teams. 
        ©2019 NBA Properties, Inc. AllRights Reserved. Officially licensed product of the National Basketball PlayersAssociation.`,
        src: [
            {index:'0',imgUrl: require('@/assets/gameDetails/NBA2K20/bottom/part1/part1.jpg'),vidioUrl:"https://weibo.com/tv/show/1034:4479432140718095?from=old_pc_videoshow",title:"NBA 2K20 MT模式"},
            {index:'1',imgUrl: require('@/assets/gameDetails/NBA2K20/bottom/part2/part2.jpg'),vidioUrl:"https://weibo.com/tv/show/1034:4471348357955593?from=old_pc_videoshow",title:"NBA2K20 全明星宣传片"},
            {index:'2',imgUrl: require('@/assets/gameDetails/NBA2K20/bottom/part3/part3.jpg'),vidioUrl:"https://weibo.com/tv/show/1034:4453185385857037?from=old_pc_videoshow",title:"NBA2K20-圣诞-麦迪卡包"}
        ]
    },
];


// WEBPACK FOOTER //
// ./src/common/js/gamesData.js